import React from 'react';
import 'react-toggle/style.css';
import styled from 'styled-components';

import IRhapsodyServer from 'src/ServerEntities/IRhapsodyServer';
import IQVeraComponents from 'src/ServerEntities/IQVeraComponents';
import ErrorBox from 'src/SharedComponents/ErrorBox';
import LoadingIndicator from 'src/SharedComponents/LoadingIndicator';
import { SessionContext } from 'src/Views/SessionContext';
import { getRhapsodyHeader, getQVeraComponents } from '../ramService';
import { ContentContainer } from '../Intersystems/IntersystemsDashboard';
import QVeraChannels from './QVeraChannels';
import QVeraDestinations from './QVeraDestinations';
import useCookie from 'src/CustomHooks/useCookie';
import ServerSelector from 'src/SharedComponents/Select/ServerSelector';


const SiteContainer = styled.ul`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: stretch;
    margin-top: 20px;
    & > div {
        margin: 0 12px;
    }
    & > div:nth-child(1) {
        margin-left: 0;
    }
    & > div:nth-last-child(1) {
        margin-right: 0;
    }
`;

interface IProps {
    selectedTypes: string[],
    changeRole: boolean,
    setChangeRole: (changeRole: boolean) => void
};

const QVeraComponents = (props: IProps) => {
    const { state, dispatch } = React.useContext(SessionContext);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");
    const [selectedNamespace, setSelectedNamespace] = useCookie<string>('selectedNamespace', '');
    const [data, setData] = React.useState(undefined as unknown as IRhapsodyServer[]);
    const [components, setComponents] = React.useState(undefined as unknown as IQVeraComponents);
    const selectedServer = state.selectedSever ?? 0;

    const setSelectedServer = (index: number) => {
        dispatch({ type: "setSelectedServer", payload: index });
    };
    const headerInfo = state.headerInfo ? state.headerInfo : data;

    React.useEffect(() => {
        if (!state.headerInfo) {
            setLoading(true);
            getRhapsodyHeader(state.webToken, (serverData: IRhapsodyServer[]) => {
                setLoading(false);
                setData(serverData);
                setError("");
                loadComponents(serverData);
                dispatch({ type: "setHeaderInfo", payload: serverData });
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        } else {
            loadComponents(headerInfo);
        }
    }, [state.webToken, selectedServer, selectedNamespace]);

    const loadComponents = (header: IRhapsodyServer[]) => {
        setLoading(true);
        if (header && header[selectedServer]) {
            getQVeraComponents(header[selectedServer].id, selectedNamespace, state.webToken, (data: IQVeraComponents) => {
                setLoading(false);
                setComponents(data);
                setError("");
            }, (errorMessage: string) => {
                setLoading(false);
                setError(errorMessage);
            });
        }
    }

    return <ContentContainer>
        <LoadingIndicator type="Linear" show={loading} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <ServerSelector headerInfo={headerInfo} selectedNamespace={selectedNamespace} setSelectedNamespace={setSelectedNamespace} selectedServer={selectedServer} setSelectedServer={setSelectedServer} />
        <SiteContainer>
            {components && components.channels && components.channels.length > 0 && <QVeraChannels data={components.channels} />}
            {components && components.destinations && components.destinations.length > 0 && <QVeraDestinations data={components.destinations} />}
        </SiteContainer>
    </ContentContainer>;
};

export default QVeraComponents;

